export const combineClassNames = (...appends: (string | undefined)[]): string => appends.filter(t => t !== undefined).join(" ");